var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPcActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7245 2.40002H1.27546C0.570928 2.40002 0 2.95382 0 3.63722V16.6428C0 17.3262 0.570928 17.88 1.27546 17.88H7.91753V19.98H5.38144C4.92 19.98 4.54639 20.3424 4.54639 20.79C4.54639 21.2376 4.92 21.6 5.38144 21.6H7.91753H16.0825H18.8041C19.2656 21.6 19.6392 21.2376 19.6392 20.79C19.6392 20.3424 19.2656 19.98 18.8041 19.98H16.0825V17.88H22.7245C23.4291 17.88 24 17.3262 24 16.6428V3.63722C24 2.95382 23.4291 2.40002 22.7245 2.40002ZM14.3505 19.98H9.64948V17.88H14.3505V19.98ZM22.268 16.2H1.73196V4.08002H22.268V16.2Z",
    fill: "#20A2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcActive);
export default __webpack_public_path__ + "static/media/PC_active.93711b87ccc8c05c5cb08f8d5a030d94.svg";
export { ForwardRef as ReactComponent };